import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5d546218"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./editedplugins/vue-m-message/dist/index.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.sass?vue&type=style&index=1&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports